export default __webpack_public_path__ + "static/transformImg4-5cce1a299152932fdbe623ebbbb3e416.png";